import { render, staticRenderFns } from "./studentGread.vue?vue&type=template&id=7a1fbc01"
import script from "./studentGread.vue?vue&type=script&lang=js"
export * from "./studentGread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports